import { TprmPortalRole } from '@evidentid/tprm-portal-lib/models/sso-provisioning';

// The six TPRM portal roles, lowest to highest privilege.
export const ROLE_OPTIONS: { value: TprmPortalRole, label: string }[] = [
    { value: 'viewer', label: 'Viewer' },
    { value: 'counter', label: 'Counter' },
    { value: 'entityManager', label: 'Entity Manager' },
    { value: 'riskManager', label: 'Risk Manager' },
    { value: 'solutionsArchitect', label: 'Solutions Architect' },
    { value: 'admin', label: 'Admin' },
];
